// extracted by mini-css-extract-plugin
export default {"cls1":"PaymentChannelType-AdvancedVeloRadioGroup_cls1__yp6Uh","cls2":"PaymentChannelType-AdvancedVeloRadioGroup_cls2__Av7U2 PaymentChannelType-AdvancedVeloRadioGroup_cls1__yp6Uh"};